import { Component, Input } from '@angular/core';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faCar, faTachometerAlt, faCog, faGasPump } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { ListedCar } from 'src/app/core/models/car.model';

@Component({
  selector: 'app-car-card',
  templateUrl: './car-card.component.html',
  styleUrls: ['./car-card.component.scss',],
})
export class CarCardComponent {

  faHeart = faHeart;
  faCog = faCog;
  faTachometerAlt = faTachometerAlt;
  faCar = faCar;
  faGasPump = faGasPump;

  @Input() car?: ListedCar;
  @Input() originalPrice?: number;
  @Input() discountedPrice?: number;

  navigateTo() {
    const _target = window.innerWidth < AppConstants.SMALL_SCREEN ? '_self' : '_blank';
    window.open(`cars/details/${this.car?.slug}-${this.car?._id}`, _target);
  }

}
